/**
 * 「你隨口說 → KIAO 整理後」那個例子的結構。
 *
 * 文案本身住在 i18n（`dictationPage.example.*`／`dictationPage.how.*`）；這裡只
 * 放結構：整理後的結果裡有幾個圈號、每個圈號對到下面哪一條說明。兩邊由同一份
 * 資料產生，改了其中一邊、忘了另一邊會被 `dictation-example.test.ts` 擋下來——
 * 圈號與說明對不起來時畫面不會壞，只會安靜地指錯行。
 */

export interface OrganizeNote {
  /** 結果裡的圈號。同時也是 HowList 的順序。 */
  ref: number
  titleKey: string
  descriptionKey: string
}

export const DICTATION_ORGANIZE_NOTES: OrganizeNote[] = [
  {
    ref: 1,
    titleKey: 'dictationPage.how.fixTitle',
    descriptionKey: 'dictationPage.how.fixDesc',
  },
  {
    ref: 2,
    titleKey: 'dictationPage.how.regroupTitle',
    descriptionKey: 'dictationPage.how.regroupDesc',
  },
  {
    ref: 3,
    titleKey: 'dictationPage.how.itemizeTitle',
    descriptionKey: 'dictationPage.how.itemizeDesc',
  },
]

/** 整理後結果的段落，依顯示順序。第一個是引言，其餘是條列項目。 */
export const DICTATION_EXAMPLE_RESULT_KEYS = [
  'dictationPage.example.outIntro',
  'dictationPage.example.outItem1',
  'dictationPage.example.outItem2',
]

const REF_PATTERN = /<ref>(\d+)<\/ref>/g

/** 從一段 i18n 標記裡取出所有圈號，依出現順序。 */
export function parseExampleRefs(markup: string): number[] {
  const refs: number[] = []
  for (const match of markup.matchAll(REF_PATTERN)) {
    refs.push(Number(match[1]))
  }
  return refs
}
